<div class="modal-header">
    <h4 style="font-size: 20px;">{{titulo}}</h4>
</div>
<div class="modal-footer">
    <button (click)="devolverRespuesta(false)" type="submit" class="buttonAnularTicket">Cancelar</button>
    <button (click)="devolverRespuesta(true)" type="submit" class="buttonImprimirTickets" ngbAutofocus>Confirmar</button>
</div>
